import type { DrawingTypes } from './drawing.interface'
import type DrawingBase from './drawing.base'

type DrawingClassMap = Record<DrawingTypes, typeof DrawingBase<any, any, any>>

let drawingClassMap: DrawingClassMap | undefined

export function initDrawingClassMap(map: DrawingClassMap) {
    drawingClassMap = map
}

export function getDrawingClassMap(): DrawingClassMap {
    if (!drawingClassMap) {
        throw new Error('Drawing class map is not initialized')
    }
    return drawingClassMap
}

export function getDrawingClass(type: DrawingTypes): typeof DrawingBase<any, any, any> {
    return getDrawingClassMap()[type]
}
